// src/components/Services/Services.js
import React, { useState, useEffect } from 'react';
import { Row, Col, Card, Typography } from 'antd';
import { 
  TruckOutlined, 
  SafetyCertificateOutlined, 
  ClockCircleOutlined,
  SyncOutlined,
  TeamOutlined,
  DashboardOutlined
} from '@ant-design/icons';
import './Services.css';

const { Title, Paragraph } = Typography;

const Services = () => {
  const [isVisible, setIsVisible] = useState(false);
  
  useEffect(() => {
    // Animation trigger on scroll
    const handleScroll = () => {
      const servicesSection = document.getElementById('services');
      if (servicesSection) {
        const rect = servicesSection.getBoundingClientRect();
        if (rect.top < window.innerHeight - 100) {
          setIsVisible(true);
        }
      }
    };

    // Initial check and add scroll listener
    handleScroll();
    window.addEventListener('scroll', handleScroll);
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const services = [
    {
      icon: <TruckOutlined />,
      title: 'Cargo Transportation',
      description: 'Reliable and efficient trucking services for all your cargo needs with real-time tracking'
    },
    {
      icon: <SafetyCertificateOutlined />,
      title: 'Secure Handling',
      description: 'Comprehensive safety protocols to ensure your goods arrive in perfect condition'
    },
    {
      icon: <ClockCircleOutlined />,
      title: 'Timely Deliveries',
      description: 'Punctual service with optimized routes to meet your delivery deadlines'
    },
    {
      icon: <SyncOutlined />,
      title: 'Flexible Scheduling',
      description: 'Adaptable service options to accommodate your unique business requirements'
    },
    {
      icon: <TeamOutlined />,
      title: 'Dedicated Support',
      description: 'Professional team providing personalized assistance throughout the process'
    },
    {
      icon: <DashboardOutlined />,
      title: 'Advanced Monitoring',
      description: 'State-of-the-art tracking technology for complete shipment visibility'
    }
  ];

  return (
    <section id="services" className="services-section">
      <div className="container">
        <div className={`services-header ${isVisible ? 'visible' : ''}`}>
          <Title level={2} className="section-title">
            Our <span className="title-underline">Services</span>
          </Title>
          <Paragraph className="section-subtitle">
            Professional cargo transportation solutions tailored to your specific requirements
          </Paragraph>
        </div>
        
        <Row gutter={[32, 32]} className="services-grid">
          {services.map((service, index) => (
            <Col xs={24} sm={12} lg={8} key={index}>
              <Card 
                className={`service-card ${isVisible ? 'visible' : ''}`}
                style={{ animationDelay: `${index * 0.1}s` }}
                hoverable
                cover={
                  <div className="service-icon-container">
                    <div className="service-icon">
                      {service.icon}
                    </div>
                  </div>
                }
              >
                <Card.Meta
                  title={<h3 className="service-title">{service.title}</h3>}
                  description={<p className="service-description">{service.description}</p>}
                />
              </Card>
            </Col>
          ))}
        </Row>
      </div>
    </section>
  );
};

export default Services;